import script from "./SectorsAccordionFAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectorsAccordionFAQ.vue?vue&type=script&setup=true&lang=ts"

import "./SectorsAccordionFAQ.vue?vue&type=style&index=0&id=fb7cbd64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb7cbd64"]])

export default __exports__